// Mirrors `useExecuteDataPipeline`'s cache key shape (`api/coreData.js`) so we
// can read the live pipeline result out of react-query without firing a fetch.
export function getCachedPipelineData (queryClient, entry) {
  if (!queryClient || !entry?.pipeline) return undefined
  const isCode = typeof entry.pipeline === 'string'
  const pipelineCode = isCode ? entry.pipeline : 'anonymous'
  const requestBody = isCode
    ? { pipelineCode, variables: entry.variables || {} }
    : { pipeline: entry.pipeline, variables: entry.variables || {} }
  const requestKey = JSON.stringify(requestBody)
  for (const bypass of [false, true]) {
    const cached = queryClient.getQueryData(['core/execute-data-pipeline', pipelineCode, requestKey, bypass])
    if (cached !== undefined) return cached
  }
  return undefined
}
